import axios from 'axios';

const livechat = {
  state() {
    return {
        liveChatHTML: '',
    }
  },
  mutations: {
    setLiveChatHTML(state, liveChatHTML) {
      state.liveChatHTML = liveChatHTML    
    },
  },
  getters: {
    liveChatHTML: (state) => {
      return state.liveChatHTML
    }
  },
  actions: {
    getLiveChatHTML(context) {
      const getLiveChatHTMLEndpoint =
      // "https://aem-qa.microchip.com:8443" +
        process.env.VUE_APP_LIVE_CHAT_URL +
        "/bin/mchp/fragmentexport.chat.js";
      // const getLiveChatHTMLEndpoint = process.env.VUE_APP_VF_URL + '/myMicrochip3/FallBackHeadFootFiles/livechat.js';
      // const getLiveChatHTMLEndpoint = "https://aem-qa.microchip.com:8443/bin/mchp/fragmentExport.chat.js";
      axios.get(getLiveChatHTMLEndpoint).then(
        async (response) => {
          if (response.status === 200) {
            const decodedContent = decodeLiveChat(response.data);
            context.commit('setLiveChatHTML', await decodedContent);
          } else {
            const error = new Error(response.message);
            throw error;
          }
        },
        (error) => {
          console.log(error);
          const getLiveChatHTMLFallbackEndpoint =
            process.env.VUE_APP_VF_URL +
            "/myMicrochip/fallbackheadfootfiles/livechat.js";
          axios.get(getLiveChatHTMLFallbackEndpoint).then(
            async (response) => {
              if (response.status === 200) {
                const decodedContent = decodeLiveChat(response.data);
                context.commit('setLiveChatHTML', await decodedContent);
              } else {
                const error = new Error(response.message);
                throw error;
              }
            },
            (error) => {
              console.log(error);
              context.commit('setLiveChatHTML', "");
            }
          );
        }
      );
    },
  }
};


async function decodeLiveChat(response) {
  response = response.replace("var xfDeliveryObj = ", "");
  response = response.replace(";", "");
  // Added below replace as a fix for AEM issue remove later //
  response = response.replaceAll(
    "http://localhost:4503",
    // "https://aem-qa.microchip.com:8443"
    process.env.VUE_APP_LIVE_CHAT_URL
  );
  const jsonData = JSON.parse(response);
  const body = document.getElementsByTagName("body")[0];
  const jsLibs = jsonData.jsLibs;
  const cssLibs = jsonData.cssLibs;

  for (let i = 0; i < cssLibs.length; i++) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = cssLibs[i];
    body.appendChild(link);
  }

  const salesForceEswScript = document.createElement("script");
  salesForceEswScript.type = "text/javascript";
  salesForceEswScript.src =
    "https://service.force.com/embeddedservice/5.0/esw.min.js";
  salesForceEswScript.async = false;
  body.appendChild(salesForceEswScript);

  const getLiveChatDecryptedStr = async function (jsonData) {
    const encodedData = jsonData.content; // The encrypted data from the Java program
    const password = "microchipKey";
    const saltString = "mchp";

    // Convert salt string to bytes
    const encoder = new TextEncoder();
    const salt = encoder.encode(saltString);

    // Convert base64 encoded data to bytes
    const encryptedData = Uint8Array.from(atob(encodedData), (c) =>
      c.charCodeAt(0)
    );

    // Split IV and cipher text
    const iv = encryptedData.slice(0, 12);
    const cipherText = encryptedData.slice(12);

    // Derive the key
    const keyMaterial = await window.crypto.subtle.importKey(
      "raw",
      encoder.encode(password),
      { name: "PBKDF2" },
      false,
      ["deriveKey"]
    );
    const key = await window.crypto.subtle.deriveKey(
      { name: "PBKDF2", salt: salt, iterations: 65536, hash: "SHA-256" },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      true,
      ["encrypt", "decrypt"]
    );

    // Decrypt
    try {
      const decryptedData = await window.crypto.subtle.decrypt(
        { name: "AES-GCM", iv: iv },
        key,
        cipherText
      );

      // Convert decrypted data to string
      const decryptedString = new TextDecoder().decode(
        new Uint8Array(decryptedData)
      );
      return decryptedString;
    } catch (e) {
      console.log(e);
    }
  };

  let decodedContent = await getLiveChatDecryptedStr(jsonData);
  decodedContent = decodedContent?.replaceAll(
    "http://localhost:4503",
    // "https://aem-qa.microchip.com:8443"
    process.env.VUE_APP_LIVE_CHAT_URL
  );
  // console.log(decodedContent) // remove this
  return { str: decodedContent, js: jsLibs };
}

export {
    livechat
};